import { client, formatQueryParams } from 'util/sdk';
import { FSP_CONFIG_VALUES_CODE } from 'consts';

const returnModel = { name: FSP_CONFIG_VALUES_CODE };

/**
 * Load FSP config values
 * @param {object} params - Parameters containing fspId
 * @returns {Promise} API response
 */
export const load = ({ fspId, ...params }) => {
  return client.executeRequest('GET', `v2/fsps/${fspId}/config-values`, {
    queryParams: formatQueryParams(params),
    returnModel,
  });
};

/**
 * Update FSP config values
 * @param {object} params - Parameters containing fspId and configItems
 * @param {object} auth - Authentication object with user id
 * @returns {Promise} API response
 */
export const update = ({ fspId, configItems, ...params }, auth) => {
  return client.executeRequest('POST', `v2/fsps/${fspId}/config-values`, {
    data: { configItems },
    queryParams: { adminUserId: auth.id, ...formatQueryParams(params) },
    returnModel,
  });
};
